/**
* DevExpress Dashboard (_chart-calc-window-definition.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import { measureCalculationWindowDefinitionSerializationsInfo } from './_measure-calc-window-definition';
export let chartDefinitionMode = {
    propertyName: 'definitionMode', modelName: '@DefinitionMode', defaultVal: 'Arguments', simpleFormAdapterItem: 'selectBoxEditor', values: {
        'Arguments': 'DashboardStringId.ChartCalculationAlongArguments',
        'Series': 'DashboardStringId.ChartCalculationAlongSeries',
        'ArgumentsAndSeries': 'DashboardStringId.ChartCalculationAlongArgumentsAndSeries',
        'SeriesAndArguments': 'DashboardStringId.ChartCalculationAlongSeriesAndArguments'
    }
};
export let chartWindowDefinitionSerializationsInfo = measureCalculationWindowDefinitionSerializationsInfo.concat([chartDefinitionMode]);
